export const getAuthorizedTokenUrl = () => `${process.env.VUE_APP_SERVICE_URL}/auth/tokens`
export const getEmailVerificationUrl = (emailAddress: string) =>
  `${process.env.VUE_APP_SERVICE_URL}/email-verification-codes/${emailAddress}`
export const getTokenVerificationRedemptionUrl = (code: string) =>
  `${process.env.VUE_APP_SERVICE_URL}/email-verification-codes/verification/${code}`
export const getUserUrl = () => `${process.env.VUE_APP_SERVICE_URL}/users`
export const getClinicsUrl = () => `${process.env.VUE_APP_SERVICE_URL}/clinics`
export const getPatientsUrl = () => `${process.env.VUE_APP_SERVICE_URL}/patients`
export const getTermsUrl = () => `${process.env.VUE_APP_SERVICE_URL}/terms-and-conditions/web`
